import React from 'react';
import styled from 'styled-components';
import { ImpCard, ImpCarousel, ImpContainer, ImpFlex, ImpFlexItem, ImpHidden, ImpPad, ImpSpacer, ImpText, colors, spacing, } from '../..';
import { BreakpointsPx } from '../../DesignSystem/design-system';
const HEADER_BREAKPOINT = '950px';
const HEADER_HEIGHT = '64px';
const DisappearOnMobile = styled(ImpContainer) `
  position: absolute;
  left: 50%;
  transform: translateX(-50%);

  @media (max-width: ${HEADER_BREAKPOINT}) {
    display: none;
  }
`;
const ContentItemContainer = styled(ImpContainer) `
  img {
    display: block;
    max-width: 250px;
  }

  @media (max-width: ${HEADER_BREAKPOINT}) {
    img {
      max-height: 24px;
      max-width: 40vw;
    }
  }
`;
const ValuePropWrapper = styled(ImpContainer) `
  && p {
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;
export default function ImpHeader({ isLoading = false, valuePropHeaderConfig, centerText, leadingContent, trailingContent, }) {
    const content = isLoading ? (React.createElement(ImpFlex, { direction: "row", justify: "space-between", align: "center", fluid: true },
        React.createElement(ImpContainer, { isLoading: true, width: "120px", height: "12px" }),
        React.createElement(ImpHidden, { hideBelow: BreakpointsPx.Mobile },
            React.createElement(ImpContainer, { isLoading: true, width: "80px", height: "12px" })),
        React.createElement(ImpContainer, { isLoading: true, width: "120px", height: "12px" }))) : (React.createElement(ImpFlex, { direction: "row", justify: "space-between", align: "center", fluid: true },
        valuePropHeaderConfig ? (React.createElement(ImpFlexItem, { flexGrow: 1 },
            React.createElement(ImpHidden, { hideAbove: BreakpointsPx.Application },
                React.createElement(ImpContainer, { onClick: valuePropHeaderConfig.onValuePropClick },
                    React.createElement(ImpFlex, { fluid: true, align: "center", gap: spacing.s },
                        React.createElement(ImpPad, { paddingLeft: 'l' },
                            React.createElement(ImpCard, { src: valuePropHeaderConfig.cardImageSrc, heightPx: 40, widthPx: 64.29, borderRadiusPx: 2, hideShadow: true, handleClick: valuePropHeaderConfig.onValuePropClick })),
                        React.createElement(ImpContainer, { width: "100%", height: HEADER_HEIGHT }, (valuePropHeaderConfig === null || valuePropHeaderConfig === void 0 ? void 0 : valuePropHeaderConfig.valueProps) && (React.createElement(ImpCarousel, { items: valuePropHeaderConfig === null || valuePropHeaderConfig === void 0 ? void 0 : valuePropHeaderConfig.valueProps.map((valueProp) => (React.createElement(ValuePropWrapper, { dataTestId: "value-prop-wrapper" },
                                React.createElement(ImpText, { handleSuperscript: true }, valueProp)))), timeInterval: 5000 }))),
                        React.createElement(ImpSpacer, { width: spacing.xs })))),
            React.createElement(ImpHidden, { hideBelow: BreakpointsPx.Application },
                React.createElement(ImpFlex, { fluid: true, align: "center" },
                    React.createElement(ImpPad, { paddingLeft: "l" },
                        React.createElement(ContentItemContainer, null, leadingContent)),
                    React.createElement(DisappearOnMobile, null,
                        React.createElement(ImpText, { typography: "body3", color: colors.content.onBackgroundVariant, handleSuperscript: true }, centerText)))))) : (React.createElement(React.Fragment, null,
            React.createElement(ImpPad, { paddingLeft: "l" },
                React.createElement(ContentItemContainer, null, leadingContent)),
            React.createElement(DisappearOnMobile, null,
                React.createElement(ImpText, { typography: "body3", color: colors.content.onBackgroundVariant, handleSuperscript: true }, centerText)))),
        React.createElement(ImpFlexItem, { flex: "0 0 auto" },
            React.createElement(ImpPad, { padding: "0px 16px" },
                React.createElement(ImpContainer, null, trailingContent)))));
    return (React.createElement(ImpContainer, { width: "100%", height: HEADER_HEIGHT, backgroundColor: colors.background.backgroundPrimary, borderBottom: `1px solid ${colors.border.borderVariant}` },
        React.createElement(ImpFlex, { fluid: true, direction: "row", align: "center", justify: "center" }, content)));
}
//# sourceMappingURL=ImpHeader.js.map